import React from 'react';
import ErrorModal from '../lib/ErrorModal/ErrorModal';
import SuccessModal from '../lib/SuccessModal/SuccesModal';
import useClearableState from './useClearableState';

export default function useLocalSuccessErrMsg(
  options = {
    modalSize: 'sm',
  }
) {
  const [loading, setLoading] = React.useState<boolean>(false);
  const [success, setSuccess, clearSuccess] = useClearableState('');
  const [err, setErr, clearErr] = useClearableState('');

  const successModal = (
    <SuccessModal
      open={!!success}
      onClose={clearSuccess}
      message={success}
      size={options.modalSize as any}
    />
  );

  const errModal = (
    <ErrorModal
      open={!!err}
      onClose={clearErr}
      message={err}
      size={options.modalSize as any}
    />
  );

  return {
    loading,
    setLoading,
    success,
    setSuccess,
    clearSuccess,
    err,
    setErr,
    clearErr,
    SuccessModal: successModal,
    ErrModal: errModal,
  };
}
